import {
  SalaryCardActions,
  SalaryCardActionTypes,
  SalaryCardState,
} from 'store/types/salaryCard'

const initialState: SalaryCardState = {
  createSalaryCardError: null,
  createSalaryCardStatus: 'idle',
}

export const orderSalaryCardReducers = (
  state = initialState,
  action: SalaryCardActions
): SalaryCardState => {
  switch (action.type) {
    case SalaryCardActionTypes.FETCH_CREATE_SALARY_CARD_REQUEST:
      return {
        ...state,
        createSalaryCardStatus: 'loading',
      }
    case SalaryCardActionTypes.FETCH_CREATE_SALARY_CARD_SUCCESS:
      return {
        ...state,
        createSalaryCardStatus: 'success',
      }
    case SalaryCardActionTypes.FETCH_CREATE_SALARY_CARD_FAILURE:
      return {
        ...state,
        createSalaryCardStatus: 'failed',
        createSalaryCardError: action.payload,
      }
    default:
      return state
  }
}
